/**
 * Legacy Emergent integration config and helpers.
 * GroceBot can use an external LLM via EMERGENT_LLM_KEY, but GroceWise works without it.
 * Frontend can load emergent-main.js for visual edits; badge visibility is controlled here.
 */
const EMERGENT_BADGE_SELECTORS = [
  '#emergent-badge',
  'a[href*="emergent"]',
];

const BADGE_TEXT_MARKERS = ['Made with Emergent', 'Emergent'];

/**
 * Hide the legacy Emergent “Made with Emergent” badge (and similar fixed elements) when configured.
 * Set REACT_APP_HIDE_EMERGENT_BADGE=true in .env to hide (default: true for a clean GroceWise UI).
 */
export function hideEmergentBadge() {
  const hideByConfig = process.env.REACT_APP_HIDE_EMERGENT_BADGE !== 'false';
  if (!hideByConfig) return;

  EMERGENT_BADGE_SELECTORS.forEach((sel) => {
    try {
      document.querySelectorAll(sel).forEach((el) => {
        el.style.setProperty('display', 'none', 'important');
        el.setAttribute('aria-hidden', 'true');
      });
    } catch (_) {}
  });

  document.querySelectorAll('div, a, span').forEach((el) => {
    const text = el.textContent || '';
    const href = el.getAttribute('href') || '';
    const isBadge =
      BADGE_TEXT_MARKERS.some((m) => text.includes(m)) ||
      (text.includes('Emergent') && href.includes('emergent'));
    if (!isBadge) return;
    let parent = el;
    while (parent && parent !== document.body) {
      if (parent.style?.position === 'fixed') {
        parent.style.setProperty('display', 'none', 'important');
        break;
      }
      parent = parent.parentElement;
    }
  });
}

export const EMERGENT_CONFIG = {
  hideBadge: process.env.REACT_APP_HIDE_EMERGENT_BADGE !== 'false',
  scriptUrl: 'https://assets.emergent.sh/scripts/emergent-main.js',
};
